import React from 'react';
import * as ComponentsLib from '@nooz-optics/nooz-components-lib';
import * as Components from '../index';
import { formatContentfulComponentProps } from '../../utils/globals';

export const returnComponentFromPath = (component) => {
  // Merge locale component with lib component
  let ComponentToReturn = { ...Components, ...ComponentsLib };

  // If path is undefined, return the nothing
  if (!component.path) {
    return <></>;
  }

  component.path.split('.').map((q) => {
    ComponentToReturn = ComponentToReturn[q];
  });

  if (ComponentToReturn) {
    const { items, path, ...definitions } = component;

    // @ts-ignore
    return (
      <ComponentToReturn
        {...{
          ...definitions,
          ...formatContentfulComponentProps(component),
        }}
      />
    );
  } else {
    return <></>;
  }
};
